import { ChevronDownIcon } from "@heroicons/react/20/solid";
import React from "react";
import { classNames } from "../utils/formatters";

interface AccordionProps {
  title: string;
  Component: JSX.Element;
  accordionOpen: boolean;
  setAccordionOpen: (state: boolean) => void;
}

const Accordion = ({
  title,
  Component,
  accordionOpen,
  setAccordionOpen,
}: AccordionProps) => {
  return (
    <div className={`rounded-md my-5 overflow-visible w-full`}>
      <button
        type="button"
        onClick={() => setAccordionOpen(!accordionOpen)}
        className={`flex  py-4 overflow-visible justify-between w-full items-center transition-all duration-300 border-b border-gray-200 pb-5`}
      >
        <span className="font-medium ">{title}</span>
        <ChevronDownIcon
          className={classNames(
            "mr-2 ml-2 h-8 w-8 text-orange-500 hover:text-orange-400 transform origin-center transition duration-200 ease-out",
            accordionOpen && "!rotate-180"
          )}
          aria-hidden="true"
        />
      </button>
      <div
        className={`w-full ${
          accordionOpen ? "pt-4" : ""
        } grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 overflow-visible transition-all duration-300 ease-in-out text-slate-600 text-sm`}
      >
        {accordionOpen ? Component : null}
      </div>
    </div>
  );
};

export default Accordion;
